import React from 'react';

export function AddIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M38 25a1 1 0 01-1 1H26v11a1 1 0 01-1 1h-2a1 1 0 01-1-1V26H11a1 1 0 01-1-1v-2a1 1 0 011-1h11V11a1 1 0 011-1h2a1 1 0 011 1v11h11a1 1 0 011 1v2z" />
    </svg>
  );
}
